<template>
  <section class="p-8 max-w-md mx-auto bg-white rounded-lg shadow-md">
    <h2 class="text-2xl font-bold mb-4">Reservation Form</h2>
    <form @submit.prevent="submitForm" class="space-y-4">
      <div>
        <label class="block text-lg">Nama:</label>
        <input v-model="form.name" class="p-2 border w-full rounded" required />
      </div>

      <div>
        <label class="block text-lg">Pesan:</label>
        <textarea
          v-model="form.message"
          class="p-2 border w-full rounded"
          rows="3"
        ></textarea>
      </div>

      <div>
        <label class="block text-lg">Konfirmasi Kehadiran:</label>
        <select
          v-model="form.attendance"
          class="p-2 border w-full rounded"
          required
        >
          <option value="" disabled>Pilih</option>
          <option value="Hadir">Hadir</option>
          <option value="Tidak Hadir">Tidak Hadir</option>
          <option value="Masih Ragu">Masih Ragu</option>
        </select>
      </div>

      <button type="submit" class="bg-blue-700 text-white px-4 py-2 rounded">
        Submit
      </button>
    </form>
  </section>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { useRoute } from "vue-router";
import { useReservationStore } from "@/stores/reservationStore";
import axios from "axios";
import { toast } from "vue3-toastify";

const route = useRoute();
const side = route.params.side as string;
const store = useReservationStore();
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

const form = reactive({
  name: "",
  message: "",
  attendance: "",
});

async function submitForm() {
  if (!form.name || !form.attendance) {
    toast.warning("Nama dan Kehadiran wajib diisi");
    return;
  }

  try {
    await axios.post(`${API_BASE_URL}/${side}/reservasi`, {
      name: form.name,
      message: form.message,
      attendance: form.attendance,
    });

    toast.success("Reservasi berhasil dikirim!");

    form.name = "";
    form.message = "";
    form.attendance = "";

    await store.fetchReservations(side);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    toast.error(err.message || "Gagal mengirim data");
  }
}
</script>
